import CheckForOutdatedBrowser from './CheckForOutdatedBrowser'

export * from './CheckForOutdatedBrowser'
export default CheckForOutdatedBrowser



// WEBPACK FOOTER //
// ./src/legacy/containers/CheckForOutdatedBrowser/index.js